<template>
  <section class="mc-rec-section mc-rec-pedidos-historico">
    <h2 class="mc-rec-section__title">
      Envios e pedidos convertidos
    </h2>
    <p class="mc-rec-section__desc">
      Clique em uma linha para ver produtos recomendados e itens comprados.
    </p>

    <b-row class="align-items-start">
      <b-col cols="12" lg="6" class="mb-4 mb-lg-0">
        <div class="mc-rec-surface mc-rec-pedidos-historico__card p-0 overflow-hidden">
          <div class="mc-rec-pedidos-historico__card-head px-3 py-2">
            Histórico de envios (recomendações)
          </div>
          <div class="px-3 py-2 border-bottom bg-white">
            <b-form-input
              v-model="buscaEnvios"
              size="sm"
              type="search"
              placeholder="Buscar por lead, telefone ou pedido…"
              class="mc-rec-pedidos-historico__search"
              autocomplete="off"
            />
          </div>
          <div class="table-responsive mb-0">
            <table class="table table-hover table-sm mc-rec-data-table mb-0">
              <thead>
                <tr>
                  <th>Lead</th>
                  <th>Telefone</th>
                  <th>Envio recomendação</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in linhasEnviosPagina"
                  :key="'e-' + row.id"
                  class="mc-rec-data-table__row"
                  @click="abrirDetalhe(row._full)"
                >
                  <td>{{ row.leadNome }}</td>
                  <td class="text-nowrap">{{ row.telefone }}</td>
                  <td>{{ fmtDataHora(row.envioEm) }}</td>
                  <td><span class="mc-rec-badge-status">{{ row.status }}</span></td>
                </tr>
                <tr v-if="!linhasEnviosFiltradas.length">
                  <td colspan="4" class="text-center text-muted py-4">
                    <template v-if="buscaEnvios.trim()">
                      Nenhum envio encontrado para esta busca.
                    </template>
                    <template v-else>
                      Nenhum registro de envio no período.
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="linhasEnviosFiltradas.length > itensPorPagina"
            class="px-3 py-2 border-top d-flex justify-content-center"
          >
            <b-pagination
              v-model="paginaEnvios"
              :total-rows="linhasEnviosFiltradas.length"
              :per-page="itensPorPagina"
              size="sm"
              class="mb-0 mc-rec-pedidos-historico__pagination"
              pills
            />
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div class="mc-rec-surface mc-rec-pedidos-historico__card p-0 overflow-hidden">
          <div class="mc-rec-pedidos-historico__card-head px-3 py-2">
            Pedidos convertidos
          </div>
          <div class="px-3 py-2 border-bottom bg-white">
            <b-form-input
              v-model="buscaPedidos"
              size="sm"
              type="search"
              placeholder="Buscar por lead, telefone ou pedido…"
              class="mc-rec-pedidos-historico__search"
              autocomplete="off"
            />
          </div>
          <div class="table-responsive mb-0">
            <table class="table table-hover table-sm mc-rec-data-table mb-0">
              <thead>
                <tr>
                  <th>Lead</th>
                  <th>Telefone</th>
                  <th>Data compra</th>
                  <th>Valor</th>
                  <th>Pedido</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in linhasPedidosPagina"
                  :key="'p-' + row.id"
                  class="mc-rec-data-table__row"
                  @click="abrirDetalhe(row._full)"
                >
                  <td>{{ row.leadNome }}</td>
                  <td class="text-nowrap">{{ row.telefone }}</td>
                  <td>{{ fmtDataHora(row.compraEm) }}</td>
                  <td>{{ fmtMoeda(row.valor) }}</td>
                  <td>{{ row.orderId }}</td>
                  <td><span class="mc-rec-badge-status">{{ row.status }}</span></td>
                </tr>
                <tr v-if="!linhasPedidosFiltradas.length">
                  <td colspan="6" class="text-center text-muted py-4">
                    <template v-if="buscaPedidos.trim()">
                      Nenhum pedido encontrado para esta busca.
                    </template>
                    <template v-else>
                      Nenhum pedido convertido no período.
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="linhasPedidosFiltradas.length > itensPorPagina"
            class="px-3 py-2 border-top d-flex justify-content-center"
          >
            <b-pagination
              v-model="paginaPedidos"
              :total-rows="linhasPedidosFiltradas.length"
              :per-page="itensPorPagina"
              size="sm"
              class="mb-0 mc-rec-pedidos-historico__pagination"
              pills
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <RecommendationOrderModal
      v-model="modalAberto"
      :order-raw="pedidoDetalhe"
      @hidden="pedidoDetalhe = null"
    />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BPagination,
  BFormInput,
} from 'bootstrap-vue'
import dayjs from 'dayjs'
import RecommendationOrderModal from './recommendation-order-modal/RecommendationOrderModal.vue'

export default {
  name: 'RecommendationPedidosHistorico',
  components: {
    BRow,
    BCol,
    BPagination,
    BFormInput,
    RecommendationOrderModal,
  },
  props: {
    /** Lista `pedidos_convertidos` da API */
    pedidos: { type: Array, default: () => [] },
    /** Opcional: histórico de envios cru da API (se existir) */
    historicoEnvios: { type: [Array, Object], default: null },
  },
  data() {
    return {
      modalAberto: false,
      pedidoDetalhe: null,
      paginaEnvios: 1,
      paginaPedidos: 1,
      itensPorPagina: 10,
      buscaEnvios: '',
      buscaPedidos: '',
    }
  },
  computed: {
    todasLinhasEnvios() {
      const api = this.normalizarHistoricoApi()
      if (api != null) return api
      return (this.pedidos || []).map((p, idx) => ({
        id: p.order_key || p.order_id || idx,
        leadNome: p.lead && p.lead.name ? p.lead.name : '—',
        telefone: p.lead && p.lead.phone ? p.lead.phone : '—',
        envioEm: p.recomendacao_enviada_em,
        status: 'Convertido',
        _full: p,
      }))
    },
    todasLinhasPedidos() {
      return (this.pedidos || []).map((p, idx) => ({
        id: p.order_key || p.order_id || idx,
        leadNome: p.lead && p.lead.name ? p.lead.name : '—',
        telefone: p.lead && p.lead.phone ? p.lead.phone : '—',
        compraEm: p.purchased_at,
        valor: p.valor_total_pedido,
        orderId: p.order_id || '—',
        status: 'Convertido',
        _full: p,
      }))
    },
    linhasEnviosFiltradas() {
      return this.filtrarLinhasEnvios(this.todasLinhasEnvios)
    },
    linhasPedidosFiltradas() {
      return this.filtrarLinhasPedidos(this.todasLinhasPedidos)
    },
    linhasEnviosPagina() {
      const rows = this.linhasEnviosFiltradas
      const start = (this.paginaEnvios - 1) * this.itensPorPagina
      return rows.slice(start, start + this.itensPorPagina)
    },
    linhasPedidosPagina() {
      const rows = this.linhasPedidosFiltradas
      const start = (this.paginaPedidos - 1) * this.itensPorPagina
      return rows.slice(start, start + this.itensPorPagina)
    },
  },
  watch: {
    pedidos: {
      handler() {
        this.paginaPedidos = 1
        this.paginaEnvios = 1
      },
      deep: true,
    },
    historicoEnvios: {
      handler() {
        this.paginaEnvios = 1
      },
      deep: true,
    },
    buscaEnvios() {
      this.paginaEnvios = 1
    },
    buscaPedidos() {
      this.paginaPedidos = 1
    },
  },
  methods: {
    /** Correspondência em texto livre ou só dígitos (telefone). */
    buscaCorrespondePartes(partes, query) {
      const q = (query || '').trim().toLowerCase()
      if (!q) return true
      const junto = partes.map(p => (p == null ? '' : String(p))).join(' ').toLowerCase()
      if (junto.includes(q)) return true
      const qDigits = q.replace(/\D/g, '')
      if (qDigits.length >= 2) {
        const digitos = junto.replace(/\D/g, '')
        if (digitos.includes(qDigits)) return true
      }
      return false
    },
    filtrarLinhasEnvios(rows) {
      const q = this.buscaEnvios
      if (!(q || '').trim()) return rows
      return rows.filter(row => {
        // eslint-disable-next-line no-underscore-dangle
        const full = row._full || {}
        const pedidoTxt = [
          full.order_id,
          full.order_key,
          row.id,
        ].filter(Boolean).join(' ')
        return this.buscaCorrespondePartes([row.leadNome, row.telefone, pedidoTxt], q)
      })
    },
    filtrarLinhasPedidos(rows) {
      const q = this.buscaPedidos
      if (!(q || '').trim()) return rows
      return rows.filter(row => {
        // eslint-disable-next-line no-underscore-dangle
        const full = row._full || {}
        const pedidoTxt = [
          row.orderId,
          full.order_id,
          full.order_key,
          row.id,
        ].filter(Boolean).join(' ')
        return this.buscaCorrespondePartes([row.leadNome, row.telefone, pedidoTxt], q)
      })
    },
    normalizarHistoricoApi() {
      let h = this.historicoEnvios
      if (h && !Array.isArray(h) && Array.isArray(h.data)) {
        h = h.data
      }
      if (!Array.isArray(h) || !h.length) return null
      return h.map((item, idx) => ({
        id: item.id || item.order_key || idx,
        leadNome: item.lead_name
          || (item.lead && item.lead.name ? item.lead.name : null)
          || item.nome
          || item.name
          || '—',
        telefone: item.lead && item.lead.phone
          ? item.lead.phone
          : (item.telefone || item.phone || '—'),
        envioEm: item.recomendacao_enviada_em || item.enviado_em || item.sent_at || item.created_at,
        status: item.status_envio || item.status || 'Enviado',
        _full: {
          ...(item.pedido_completo || item),
          ...(item.lead_name
            ? {
              lead_name: item.lead_name,
              telefone: item.telefone || item.phone,
            }
            : {}),
        },
      }))
    },
    fmtDataHora(iso) {
      if (!iso) return '—'
      return dayjs(iso).format('DD/MM/YYYY HH:mm')
    },
    fmtMoeda(v) {
      if (v == null || v === '') return '—'
      const n = typeof v === 'number' ? v : parseFloat(v)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    abrirDetalhe(pedido) {
      let p = pedido
      const oid = p && p.order_id != null ? String(p.order_id) : null
      const okey = p && p.order_key != null ? String(p.order_key) : null
      const hasRec = p && p.produtos_recomendados && p.produtos_recomendados.length
      const hasComp = p && p.produtos_comprados && p.produtos_comprados.length
      const precisaMerge = p && !hasRec && !hasComp && (oid || okey)
      if (precisaMerge) {
        const match = (this.pedidos || []).find(x => {
          if (oid && String(x.order_id) === oid) return true
          if (okey && String(x.order_key) === okey) return true
          return false
        })
        if (match) p = match
      }
      this.pedidoDetalhe = p
      this.modalAberto = true
    },
  },
}
</script>
